import { iQCResult } from "@sdk/agent-quality-control/qc-results.models";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { qcResultsDefaultQueryConfig } from "./qc-results-default-query";

export const {
  slice: QCResultsSlice,
  reducers: QCResultsSliceReducer,
  actions: {
    setEntityQueryResults: setQCResultsQueryResults,
    setEntity: setQCResult,
    setEntities: setQCResults,
    patchEntity: patchQCResult,
    addNewEntity: addNewQCResult,
    setEntityFetchingStatus: setQCResultFetchingStatus,
    setEntitiesFetchingStatus: setQCResultsFetchingStatus,
    setEntityFailedStatus: setQCResultFailedStatus,
    setEntityQueryError: setQCResultsQueryError,
    resetQuery: resetQCResultsQuery,
    setQueryList: setQCResultQueryList,
  },
} = CreateEntitySlice<iQCResult>({
  sliceName: "qcResults",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...qcResultsDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
